import React from "react";
import { Routes, Route } from "react-router-dom";

import LandingPage from "./app/LandingPage/LandingPage";
import AboutPage from "./app/AboutPage/AboutPage";
import TermsPage from "./app/TermsPage/TermsPage";
import DonationsPage from "./app/DonationsPage/DonationsPage";
import SigningPage from "./app/SigningPage/SigningPage";
import SharePage from "./app/SharePage/SharePage";
import FormPage from "./app/FormPage/FormPage";

import LoginPage from "./dashboard/LoginPage/LoginPage";
import ProblemListPage from "./dashboard/ProblemListPage/ProblemListPage";
import ProblemCreatePage from "./dashboard/ProblemCreatePage/ProblemCreatePage";
import ProblemEditPage from "./dashboard/ProblemEditPage/ProblemEditPage";
import UserListPage from "./dashboard/UserListPage/UserListPage";
import UserEditPage from "./dashboard/UserEditPage/UserEditPage";
import ProblemSharePage from "./dashboard/ProblemSharePage/ProblemSharePage";
import FormDashboard from "./dashboard/FormsPage/FormDashboard";
import FormEdit from "./dashboard/FormEditPage/FormEdit";

import NotFoundPage from "./NotFoundPage";

import AppLayout from "../layouts/AppLayout";
import DashboardLayout from "../layouts/DashboardLayout";

import { AuthProvider } from "../hooks/useAuth";


function AppRouter() {
  return (
    <AuthProvider>
      <Routes>
        
        <Route element={<AppLayout />} >
          <Route path="/" element={<LandingPage />}/>
          <Route path="/about" element={<AboutPage />} />
          {/*<Route path="/terms" element={<TermsPage />} />*/}
          {/*<Route path="/donations" element={<DonationsPage />} />*/}
          <Route path="/item/:ProblemId" element={<SigningPage />} />
          <Route path="form" element={<FormPage />} />
          {/*<Route path="/item/:ProblemId/share" element={<SharePage />} />*/}
        </Route>

        <Route path="/dashboard" element={<DashboardLayout />} >
          <Route path="" element={<ProblemListPage />} />
          <Route path="problem/create" element={<ProblemCreatePage />} />
          <Route path="problem/edit/:ProblemId" element={<ProblemEditPage />} />
          <Route path="problem/share/:ProblemId" element={<ProblemSharePage />} />
          
          <Route path="forms" element={<FormDashboard />} />
          <Route path="forms/create" element={<FormEdit />} />
          <Route path="forms/edit/:id" element={<FormEdit />} />
          
          <Route path="users" element={<UserListPage />} />
          <Route path="user/edit/:UserId" element={<UserEditPage />} />
        </Route> 
        
        <Route path="dashboard/login" element={<LoginPage />} />
        <Route path="*" element={<NotFoundPage />} />
        
      </Routes>
    </AuthProvider>
  );
}

export default AppRouter;
